import { useState } from "react"


export default function TabbedView({
    tabs:rawTabs=[],
    tab,
    setTab,
    ...props
}){
    const tabs = rawTabs.map(t => typeof t == 'string' ? ({name:t}) : t)

    const tabsOnly = !!tab && !!setTab
    const [currentTabLocal,setCurrentTabLocal] = useState(1)

    const currentTab = tab ?? currentTabLocal
    const setCurrentTab = setTab || setCurrentTabLocal

    const allTabChildren = props.children || []
    const currentTabContent = tabsOnly? allTabChildren : allTabChildren[currentTabLocal-1]

    return <div className="IPOCard-List">
    <div className="row makerel">
      <div className="makerelnewFlex">
        {tabs.map((tab,i) => {
            const isActive = currentTab == i+1

            return <div className="flexitems flexitems-1 paddings">
            <button
                type="button"
                className={` tabDesign ${
                    (isActive) ? " w-15 activeStateIPO" : " w-15"
                }`}
                onClick={() => setCurrentTab(i+1)}
            >
                <p>{tab.name|| tab.label}</p>{" "}
            </button>
            </div>
        })}

        
      </div>
      <div className="underlineipo"></div>
    </div>

    {currentTabContent}

    </div>

}